<div style="height:8px;">&nbsp;</div>
@if (hasPlan) {
  <div fxFlex="95" fxLayout="row" style="margin-bottom:4px;">
    <span aria-label="Plan Code">{{ plan }}</span>&nbsp;&bull; {{ date | date : 'M/d/yy' }}
  </div>
}
<div fxFlex="95" fxLayout="row">
  <div fxFlex="40" fxLayout="column">
    Completed Enrollment: {{complete}}
  </div>
  <div fxFlex="40">
    Incomplete Enrollment:
    @if (hasPlan) {
      <a [href]="benefitPlanUrl">{{incomplete}}</a>
    }
    @if (!hasPlan) {
      <span>{{incomplete}}</span>
    }
  </div>
  <div fxFlex="20" fxLayout="column">
    Total: {{total}}
  </div>
</div>

<chartjs-container [config]="chartConfig" [heightPx]="75">
</chartjs-container>
